import React from 'react';
import { IAuditoriaAdiantamentoResultado } from '../interfaces/IAuditoriaAdiantamento';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaAdiantamentoResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Competência de Adiantamentos não é um tributo — é uma auditoria complementar
// que verifica se contas de adiantamento (Ativo Circulante) foram baixadas dentro de 60 dias.
// Segue o mesmo padrão de seção própria já usado para os outros módulos de auditoria.
const AuditoriaResumoAdiantamento: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.adiantamentosEstagnados?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Competência de Adiantamentos</h3>
      <p className='text-muted'>
        Auditoria complementar — contas de adiantamento com saldo devedor além do prazo parametrizado (padrão: 60 dias).
        Aging elevado é indicador de revisão, não conclusão automática de despesa omitida. Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th
                className='text-end'
                title='Soma dos saldos de adiantamentos vencidos — exposição financeira sem confirmação fiscal'
              >
                Exposição Financeira
              </th>
              <th
                className='text-center'
                title='Aging > 2× prazo aplicável — possível despesa omitida, documentação urgente'
              >
                Pendentes
              </th>
              <th className='text-center' title='Aging > prazo parametrizado — revisão recomendada'>
                Vencidos
              </th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ADIANTAMENTO')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Competência de Adiantamentos</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status === 'PENDENTE_VALIDACAO' ? 'PENDENTE' : resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>
                    {totalOcorrencias} adiantamento{totalOcorrencias === 1 ? '' : 's'} vencido{totalOcorrencias === 1 ? '' : 's'} identificado{totalOcorrencias === 1 ? '' : 's'} no período
                  </div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td
                className={`text-end ${resultado.impactoFinanceiroTotal > 0 ? 'auditoria-col-highlight' : ''}`}
                title='Exposição financeira total — validar documentação antes de qualquer conclusão fiscal'
              >
                {formatCurrency(resultado.impactoFinanceiroTotal)}
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-pendente'>{resultado.totalPendentes}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoAdiantamento;
